module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/chevron-down-0881589fcb941901e12cecfddb90970b.svg";